import React, { useState } from 'react'

import { Alert } from '../components/ui-blocks'

import { LoginForm } from '../components'
import { useUser } from '../contexts/user'
import { useForm, followRedirectUrl, getCommunitySignInUrl, getFrontEndUrlFromRedirection, login } from '../helpers'

import { loginFields } from '../components/Auth/auth-forms'


export const Login = () => {
  const { userToken, setUserToken } = useUser()

  const [form] = useForm(loginFields)

  const [error, setError] = useState(false)
  const [isLoading, setLoading] = useState(false)


  const submit = async () => {
    setLoading(true)

    try {
      const response = await login(form.values)

      setUserToken(response.data.jwt)
    } catch (err) {
      setError(true)
      setLoading(false)
    }
  }


  if (userToken) {
    followRedirectUrl()

    return null
  }


  // The site's /login/ design (SPEC.md, "Sign-in"): community first, then the password.
  return (
    <div className="signin-page">
      <header className="signin-bar">
        <a href={getFrontEndUrlFromRedirection()} className="dashboard-brand" aria-label="ConsultDex">
          <img src={`${process.env.PUBLIC_URL}/brand/consultdex-icon.png`} alt="" width="32" height="32" />
          <img
            src={`${process.env.PUBLIC_URL}/brand/consultdex-white.png`}
            alt="ConsultDex"
            className="dashboard-wordmark"
            width="150"
            height="45"
          />
        </a>
      </header>

      <main className="signin-main">
        <h1 className="signin-title">Sign in to your dashboard</h1>
        <p className="signin-lead">Build your courses and keep your listing up to date.</p>

        <a className="signin-community" href={getCommunitySignInUrl()}>
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" fill="none"
            stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 9.5a5 5 0 0 1-5 5H6l-3 2.5v-3.1A5 5 0 0 1 9 4.5h0a5 5 0 0 1 5 5Z" />
            <path d="M10.5 16.4A5 5 0 0 0 15 19.5h3l3 2.5v-3.1a5 5 0 0 0-3.4-7.9" />
          </svg>
          <span>Continue with ConsultDex Community</span>
        </a>
        <p className="signin-hint">In the community forum? Use that account. No new password.</p>
        <p className="signin-or"><span>or sign in with your consultdex.com password</span></p>

        {error && (
          <Alert variant="danger" className="mb-4">
            That email and password did not match. Try again, or use the community button above.
          </Alert>
        )}

        {!!Object.keys(form.fields).length && (
          <LoginForm
            fields={form.fields}
            isFormValid={form.isValid}
            isLoading={isLoading}
            onSubmit={submit}
          />
        )}

        <p className="signin-alt">
          <a href={`${process.env.REACT_APP_WP_API_URL}/login/?action=lostpassword`}>Forgot your password?</a>
        </p>
        <p className="signin-back">
          <a href={getFrontEndUrlFromRedirection()}>Back to consultdex.com</a>
        </p>
      </main>
    </div>
  )
}
